/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListingAgentDto
 */
export interface ListingAgentDto {
    /**
     * 
     * @type {string}
     * @memberof ListingAgentDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListingAgentDto
     */
    dre: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListingAgentDto
     */
    brokerage: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListingAgentDto
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListingAgentDto
     */
    email: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ListingAgentDto
     */
    lastSourceUpdateDate: Date | null;
}

/**
 * Check if a given object implements the ListingAgentDto interface.
 */
export function instanceOfListingAgentDto(value: object): value is ListingAgentDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dre' in value) || value['dre'] === undefined) return false;
    if (!('brokerage' in value) || value['brokerage'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('lastSourceUpdateDate' in value) || value['lastSourceUpdateDate'] === undefined) return false;
    return true;
}

export function ListingAgentDtoFromJSON(json: any): ListingAgentDto {
    return ListingAgentDtoFromJSONTyped(json, false);
}

export function ListingAgentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingAgentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dre': json['dre'],
        'brokerage': json['brokerage'],
        'phone': json['phone'],
        'email': json['email'],
        'lastSourceUpdateDate': (json['lastSourceUpdateDate'] == null ? null : new Date(json['lastSourceUpdateDate'])),
    };
}

export function ListingAgentDtoToJSON(json: any): ListingAgentDto {
    return ListingAgentDtoToJSONTyped(json, false);
}

export function ListingAgentDtoToJSONTyped(value?: ListingAgentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'dre': value['dre'],
        'brokerage': value['brokerage'],
        'phone': value['phone'],
        'email': value['email'],
        'lastSourceUpdateDate': ((value['lastSourceUpdateDate'] as any).toISOString()),
    };
}

